module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_12.918a550c.png";